import * as React from 'react';
import { ReactElement, useCallback } from 'react';
import { FeedbackCycleDto } from '../../../../../../types/FeedbackCycleDto';
import api from '../../../../../api';
import { YOUR_COMPANY_FEEDBACK_SELECT_CYCLE } from '../../../../../routes';
import { getAdminRouteForNavigation } from '../../../../../routes-pairs';
import RouteError from '../../../../../routing/RouteError/index';
import { handleApiErrors, withData } from '../../../../hoc/withData';
import { goToUrl } from '../../../../services/Router';
import { prependAppPath } from '../../../../services/Url';
import { LoadingIndicator } from '../../components/LoadingIndicator';
import { CycleFeedbackProvidePreviewProps } from '../../components/Preview';
import { CycleFeedbackResponseError, individualizedErrors } from '../FeedbackProvide';

type OuterProps = {
    cycleId: string;
    prevPath?: string;
};

type AddedProps = {
    response: FeedbackCycleDto;
    component: React.FC<CycleFeedbackProvidePreviewProps>;
};

const DEFAULT_CLOSE_PATH = prependAppPath(getAdminRouteForNavigation(YOUR_COMPANY_FEEDBACK_SELECT_CYCLE));

function FeedbackPreviewPage({
    component: CycleFeedbackProvidePreviewFromRequest,
    prevPath,
    response,
}: OuterProps & AddedProps): ReactElement {
    const onCloseRedirect = useCallback(() => {
        goToUrl(prevPath || DEFAULT_CLOSE_PATH);
    }, [prevPath]);

    return (
        <CycleFeedbackProvidePreviewFromRequest
            canSeeEditButton={true}
            onClose={onCloseRedirect}
            cycleCallback={() => Promise.resolve(response)}
        />
    );
}

const errorComponent = handleApiErrors<OuterProps, CycleFeedbackResponseError>(individualizedErrors, RouteError);

export default withData<AddedProps, OuterProps>({
    observe: {
        response: ({ cycleId }) => api.feedbackCycles.getCyclePreview.createObservable(cycleId),
    },
    resolve: {
        component: () =>
            import(/* webpackChunkName: 'FeedbackProvideZen' */ '../../components/Preview').then(
                ({ CycleFeedbackProvidePreviewFromRequest }) => CycleFeedbackProvidePreviewFromRequest
            ),
    },
    pendingComponent: LoadingIndicator,
    errorComponent,
})(FeedbackPreviewPage);
